import { toast, toastTypeEnum } from 'common/utils';
import { observable, action, makeObservable } from 'mobx';
import { getUserReport, toggleIsReviewAlert } from 'services/report';
import { getApiErrorMessage } from 'services/utils';
import { RootStore } from 'stores';
import { IgetUserApiData, pagination, sortByParams } from 'types/index';

export type IInitialState = {
  data: {
    userReports: any[];
    exportData: string;
    total: number | null;
    getUserReportsParams: sortByParams & pagination;
  };
  ui: {
    isUserReportLoading: boolean;
    disableUserReportLoading: null | string;
    isReviewAlertLoading: boolean;
  };
};

export const initialState: IInitialState = {
  data: {
    userReports: [],
    total: null,
    exportData: '',
    getUserReportsParams: { limit: 10, offset: 0 }
  },
  ui: {
    isUserReportLoading: false,
    disableUserReportLoading: null,
    isReviewAlertLoading: false
  }
};

export class UsersActivityReport {
  state: IInitialState = initialState;
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeObservable(this, {
      state: observable,
      getUserReports: action,
      toogleSwitch: action,
      setState: action,
      reset: action
    });

    this.rootStore = rootStore;
    /* use this space to hydrate state from localStorage */
  }

  getUserReports = async (params: IgetUserApiData, showLoading = true) => {
    try {
      showLoading &&
        this.setState({
          ui: { ...this.state.ui, isUserReportLoading: true }
        });

      if (!params?.search || params?.search.length === 0) {
        delete params.search;
      }
      const { data } = await getUserReport({ ...params });

      this.setState({
        data: {
          ...this.state.data,
          userReports: data.data.rows,
          total: data.data.count
        }
      });
    } catch (error) {
      const message = getApiErrorMessage(error);
      toast(toastTypeEnum.error, message);
    } finally {
      this.state.ui.isUserReportLoading = false;
    }
  };

  toogleSwitch = async (data: {
    id: string;
    is_checked: boolean;
  }): Promise<boolean | undefined | void> => {
    try {
      this.setState({
        ui: { ...this.state.ui, isUserReportLoading: true }
      });
      const result = await toggleIsReviewAlert(data);
      const findIndex = this.state.data.userReports.findIndex(
        value => value.id === data.id
      );
      if (result && findIndex >= 0) console.log(data.id);

      const keyToUpdate = data.id;
      const valueToUpdate = data.is_checked;
      //this.state.data.parts[findIndex][data.key] = data.bool;
      const updatedReports = this.state.data.userReports.map(
        (report: any, index) =>
          index === findIndex
            ? {
                ...report,
                [keyToUpdate]: valueToUpdate
              }
            : report
      );

      this.setState({
        data: {
          ...this.state.data,
          userReports: updatedReports
        }
      });
      // this.syncPartsInBackground();
      return true;
    } catch (error) {
      const message = getApiErrorMessage(error);
      toast(toastTypeEnum.error, message);
    } finally {
      this.setState({
        ui: { ...this.state.ui, isUserReportLoading: false }
      });
    }
  };
  setState = (params: Partial<IInitialState>) => {
    const { state } = this;
    this.state = {
      ...state,
      ...params
    };
    /* use this space to save/sync state with localStorage */
  };

  reset = () => {
    this.state = initialState;
    /* use this space to reset localStorage in case if you're persisting this state */
  };
}
